"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalClipVisibility = void 0;
var PortalClipVisibility;
(function (PortalClipVisibility) {
    PortalClipVisibility["Public"] = "public";
    PortalClipVisibility["Unlisted"] = "unlisted";
    PortalClipVisibility["Blacklisted"] = "blacklisted";
})(PortalClipVisibility = exports.PortalClipVisibility || (exports.PortalClipVisibility = {}));
//# sourceMappingURL=portal-clip-visibility.js.map